// extracted by mini-css-extract-plugin
export default {"container":"SetupNewCampaignModeEdit_container__NqhIs","wrapperInput":"SetupNewCampaignModeEdit_wrapperInput__ka64x"};